import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as actions from "../../../actions";

import { ModuleDetails } from "../components/module_details";
import { Popup } from "../../../components/pop-up";
import { UPDATEMODULES_RESPONSE } from "../../../constants/action_types";
import { FlatButton, IconButton } from "../../../components/buttons";

function CompanyModules({ company_uid }) {
  const dispatch = useDispatch();

  const _modules = useSelector((state) => state.company.modules);
  const updateResponse = useSelector((state) => state.company.update_response);

  const [selectedModules, setModules] = useState([]);
  const [activatedModules, setActivedModules] = useState();
  const [deactivatedModules, setDeactivedModules] = useState();

  const [editMode, setEditMode] = useState(false);
  const [openModal, setOpenModal] = useState();

  useEffect(() => {
    dispatch(actions.GETMODULES_REQ({ company_uid }));
  }, []);

  useEffect(() => {
    const _module_uids = _modules.data?.map((m) => m.module.module_uid) || [];
    setModules([..._module_uids]);
  }, [_modules.data]);

  useEffect(() => {
    const _module_uids = _modules.data?.map((m) => m.module.module_uid);

    const activated = selectedModules?.filter(
      (_module) => !_module_uids.includes(_module)
    );
    const deactivated = _module_uids?.filter(
      (_module) => !selectedModules.includes(_module)
    );
    setActivedModules(activated);
    setDeactivedModules(deactivated);
  }, [selectedModules]);

  useEffect(() => {
    if (updateResponse.type === UPDATEMODULES_RESPONSE) {
      setEditMode(false);
    }
  }, [updateResponse]);

  const handleSave = () => {
    setOpenModal(undefined);
    dispatch(
      actions.UPDATEMODULES_REQ({
        company_uid: company_uid,
        activated: activatedModules,
        deactivated: deactivatedModules,
      })
    );
  };
  return (
    <div class="h-full mt-3">
      <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
        <div class="p-2">
          <div class="flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                <div class="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                  <h3 class="text-lg font-semibold leading-6 text-gray-900">
                    Module Access
                  </h3>
                  <div class="mt-3 sm:ml-4 sm:mt-0">
                    <div class="flex items-center justify-center space-x-3">
                      {!editMode ? (
                        <IconButton
                          onClick={() => {
                            setEditMode(true);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-4 h-4"
                          >
                            <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
                          </svg>
                        </IconButton>
                      ) : (
                        <>
                          <FlatButton
                            appearance="secondary"
                            onClick={() => {
                              setModules(
                                _modules.data?.map(
                                  (_module) => _module.module.module_uid
                                )
                              );
                              setEditMode(false);
                            }}
                            className="w-[100px] inline-flex justify-center items-center gap-x-1.5"
                          >
                            Cancel
                          </FlatButton>
                          <FlatButton
                            className="w-[100px] inline-flex justify-center items-center gap-x-1.5"
                            onClick={() => {
                              setOpenModal("pop-up");
                            }}
                          >
                            Save
                          </FlatButton>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <ModuleDetails
                  readOnly={!editMode}
                  showPlans={editMode}
                  modules={selectedModules || []}
                  onChange={setModules}
                  moduleWithCount={_modules.moduleCountObject}
                  company_uid={company_uid}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup
        modalState={[openModal, setOpenModal]}
        onConfirm={handleSave}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {activatedModules?.length > 0 &&
                `${activatedModules.length} module(s) will be activated.`}
              {deactivatedModules?.length > 0 &&
                `${deactivatedModules.length} module(s) will be deactivated.`}
              Do you want to proceed?
            </h3>
          </>
        }
      />
    </div>
  );
}

export default CompanyModules;
